import { j as p } from "../../jsx-runtime-82a9ddf6.js";
import { cva as y, cn as c } from "../../lib/cn.js";
const g = y(
  "",
  {
    variants: {
      weight: {
        regular: "font-normal",
        medium: "font-medium",
        bold: "font-bold"
      },
      size: {
        xs: "text-xs",
        sm: "text-sm",
        base: "text-base",
        lg: "text-lg",
        xl: "text-xl",
        "2xl": "text-2xl",
        "3xl": "text-3xl",
        "4xl": "text-4xl"
      },
      family: {
        sans: "font-sans",
        serif: "font-serif",
        mono: "font-mono"
      },
      align: {
        left: "text-left",
        center: "text-center",
        right: "text-right",
        justify: "text-justify",
        start: "text-start",
        end: "text-end"
      },
      type: {
        primary: "text-slate-900 dark:text-white",
        secondary: "text-slate-500 dark:text-slate-400"
      }
    }
  }
), h = ({
  component: t = "p",
  children: e,
  weight: s = "regular",
  size: a = "base",
  family: r = "sans",
  align: x = "left",
  className: o,
  type: n = "primary",
  ...l
}) => {
  const i = t, m = g({ weight: s, size: a, family: r, align: x, type: n }), f = c(m, o);
  return /* @__PURE__ */ p.jsx(
    i,
    {
      className: f,
      ...l,
      children: e
    }
  );
};
export {
  h as Typography
};
